/*
 * dga-smooth-anchor.js
 * Langzame, vloeiende smooth-scroll voor alle in-page anker-links (a[href^="#"]).
 * Respecteert prefers-reduced-motion. Site-breed ingeladen via layout/theme.liquid.
 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DURATION = 1100;   // ms — langzaam & vloeiend
  var EXTRA_MARGIN = 24; // extra ademruimte onder de header

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  // Meet de hoogte van de (sticky) header zodat de target er niet onder verdwijnt
  function headerOffset() {
    var sel = ['sticky-header', '.header-wrapper', '.section-header', '.shopify-section-header', '#shopify-section-header'];
    var h = 0;
    for (var i = 0; i < sel.length; i++) {
      var el = document.querySelector(sel[i]);
      if (el) {
        var pos = getComputedStyle(el).position;
        var rectH = el.getBoundingClientRect().height;
        if ((pos === 'sticky' || pos === 'fixed') && rectH > h) h = rectH;
        else if (rectH > h && el.getBoundingClientRect().top <= 0) h = rectH;
      }
    }
    if (!h) h = 90;
    return h + EXTRA_MARGIN;
  }

  function scrollToEl(el) {
    var startY = window.pageYOffset;
    var targetY = startY + el.getBoundingClientRect().top - headerOffset();
    var dist = targetY - startY;
    var startTime = null;

    function step(ts) {
      if (startTime === null) startTime = ts;
      var p = Math.min((ts - startTime) / DURATION, 1);
      window.scrollTo(0, startY + dist * easeInOutCubic(p));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) !== '#' || href === '#') return;

    var id = decodeURIComponent(href.slice(1));
    var target = document.getElementById(id) || document.querySelector('[name="' + id + '"]');
    if (!target) return;

    e.preventDefault();
    scrollToEl(target);
    if (history.pushState) history.pushState(null, '', href);
  }, false);
})();
